<template>
  <case-related-procedure></case-related-procedure>
</template>

<script>
import CaseRelatedProcedure from '../components/case-related-procedure/index';

export default { components: { CaseRelatedProcedure } };
</script>
